import { SessionConfig } from '@movilidad/app-core';
import { User } from '@shared/models';

/**
 * Lo que la sesión de @movilidad/app-core (TEC-293) necesita saber de Movilidad: a dónde mandan los
 * guards y qué llaves propias borra el logout. Funciones puras del usuario: las usan los guards de la
 * lib, `captureBirthdayGuard` y `AuthService`, sin instanciar nada.
 */

/** Preparatoria con verificación de edad: falta la fecha de nacimiento o aceptar la política. */
export function needsBirthdayCapture(user: User | null): boolean {
  if (!user) return false;
  const flag = !!user?.campus_actual?.verificar_edad_preparatoria;
  const isPrepa = (user?.user_type?.name || '').trim().toLowerCase() === 'preparatoria';
  if (!flag || !isPrepa) return false;
  if (!user?.birthday) return true;
  return !!user?.requires_age_policy_acceptance;
}

/** La pantalla de inicio de un usuario con sesión. */
export function getRedirectPath(user: User): string {
  if (!user || !user.active) return '/email-confirmation';
  if (needsBirthdayCapture(user)) return '/capture-birthday';
  if (user.type2 === 'transportec-driver' && user.campus_registered > 2) return '/tecservice-driver/stops';
  return '/tecservice-transportec/wallet';
}

export const MOVILIDAD_SESSION: SessionConfig<User> = {
  routes: {
    signedOut: '/initial',
    home: getRedirectPath,
    pendingStep: (user) => (needsBirthdayCapture(user) ? '/capture-birthday' : null),
  },
  clearOnLogout: [
    'subscription',
    'realtrip',
    'bus',
    'routes',
    // Keys owned by RecentStopsService — cleared here to avoid cross-user leaks on shared devices.
    'ticket-search:recents:go',
    'ticket-search:recents:return',
  ],
};
